import { Stack, Group, Text, Progress } from '@mantine/core';
import { fmt } from '../lib/format';

export function RankBars({
  items,
  color = 'brand.6',
  rtl = false,
  emptyLabel = 'No data',
}: {
  items: Array<{ label: string; value: number }>;
  color?: string;
  rtl?: boolean;
  emptyLabel?: string;
}) {
  if (!items.length) {
    return (
      <Text size="sm" c="dimmed" ta="center" py="md">
        {emptyLabel}
      </Text>
    );
  }
  const max = Math.max(1, ...items.map((i) => i.value));
  return (
    <Stack gap="xs">
      {items.map((it, i) => (
        <div key={i}>
          <Group justify="space-between" gap="xs" wrap="nowrap">
            <Text size="sm" c="navy.9" truncate="end" style={rtl ? { direction: 'rtl' } : undefined}>
              {it.label}
            </Text>
            <Text size="sm" fw={600} className="tnum" c="navy.9" style={{ flexShrink: 0 }}>
              {fmt(it.value)}
            </Text>
          </Group>
          <Progress value={(it.value / max) * 100} color={color} radius="xl" size="sm" mt={4} />
        </div>
      ))}
    </Stack>
  );
}
